import React, { useMemo } from "react";

import styled from "styled-components";
import WaterSlider from "./WaterSlider";
import Info from "./Info";

const SliderAndInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 20px;
`;

const Title = styled.h3`
  font-family: "Rubik", sans-serif;
  font-size: 20px;
  font-weight: 500;
`;

const WaterQuantity = ({
  onChangeSlider, waterQuantity, waterCut
}) => {
  const coefficient = useMemo(() => {
    return waterQuantity ? ((parseFloat(waterQuantity) - parseFloat(waterCut)) / parseFloat(waterQuantity)) * 100 : 100;
  }, [waterCut, waterQuantity]);

  return (
    <div style={{ padding: "30px", borderTop: "2px solid #F6F8FF", borderBottom: "2px solid #F6F8FF" }}>
      { waterQuantity > 0 && (
        <React.Fragment>
          <Title>Quantidade de Água</Title>

          <SliderAndInfoContainer>
            <WaterSlider waterValue={coefficient} onChangeSlider={onChangeSlider} />
            <Info sliderValue={coefficient} waterQuantity={waterQuantity} />
          </SliderAndInfoContainer>
        </React.Fragment>
      )}
    </div>
  );
};

export default WaterQuantity;
